import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { LightbulbOutlined } from "@mui/icons-material";
import { SxProps } from "@mui/system";
import { useAppSelector } from "@/store/hooks";
import { infrastructureArchitectureRecommendationImprovementDataSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureRecommendationImprovementDataSelector";
import { anomaliesHtmlStyle } from "@/components/common/explain-with-ai-drawer/components/body/components/utils/constants";

export const InfrastructureArchitectureRecommendationDrawerBodyImprovement: FC =
  () => {
    const improvement = useAppSelector(
      infrastructureArchitectureRecommendationImprovementDataSelector,
    );

    if (!improvement) {
      return null;
    }

    return (
      <Stack spacing={1.5} sx={stackStyles}>
        <Stack direction="row" spacing={1} alignItems="center">
          <LightbulbOutlined color="primary" />
          <Typography variant="subtitle2" fontWeight="medium">
            Proposed Improved Architecture Layout
          </Typography>
        </Stack>

        <Stack
          px={1}
          sx={{
            ...anomaliesHtmlStyle,
            overflowY: "auto",
            overflowX: "hidden",
          }}
          dangerouslySetInnerHTML={{ __html: improvement ?? "" }}
        />
      </Stack>
    );
  };

const stackStyles: SxProps = {
  px: 2,
  pt: 3,
  pb: 1,
  border: 1,
  borderRadius: 3,
  overflow: "hidden",
  borderColor: "primary.main",
  height: "100%",
  background:
    "linear-gradient(135deg,rgba(180, 192, 255, 0.35) 0%,rgba(245, 186, 255, 0.35) 100%)",
  transition: "height 0.3s ease-in-out, flex 0.3s ease-in-out",
};
